<template>
  <div v-if="theme" style="margin: 0 15px">
    <el-tabs v-model="tabType">
      <el-tab-pane label="模板详情" name="Details"></el-tab-pane>
      <el-tab-pane label="模板说明" name="Content"></el-tab-pane>
      <el-tab-pane label="更新日志" name="ChangeLog"></el-tab-pane>
    </el-tabs>

    <template v-if="tabType == 'Content'">
      <p v-html="theme.content"></p>
    </template>
    <template v-if="tabType == 'ChangeLog'">
      <p v-html="theme.changeLog"></p>
    </template>
    <template v-if="tabType == 'Details'">
      <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
            <colgroup>
              <col width="180" />
              <col />
            </colgroup>
            <tbody>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>模板状态</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <el-link :type="theme.state == 'Published' ? 'success' : 'danger'" :underline="false">
                      {{ getResourceState(theme) }}
                    </el-link>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>模板作者</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">{{ theme.userName }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>模板名称</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">{{ theme.name }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>模板价格</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <span v-if="theme.price == 0">免 费</span>
                    <span v-else>￥{{ theme.price }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>模板简介</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">{{ theme.summary }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>标签</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell" v-if="theme.tags">
                    <el-link v-for="tag in theme.tags" :key="tag" type="primary" style="margin-right: 5px">
                      {{ tag }}
                    </el-link>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>兼容性</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell" v-if="theme.compatibilities">
                    <el-link
                      v-for="compatibility in theme.compatibilities"
                      :key="compatibility"
                      type="primary"
                      style="margin-right: 5px"
                    >
                      {{ compatibility }}
                    </el-link>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>封面图</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <a :href="getStorageUrl(theme.userName, theme.name, theme.coverUrl)" target="_blank">
                    <el-image
                      style="max-height: 400px"
                      :src="getStorageUrl(theme.userName, theme.name, theme.coverUrl)"
                    ></el-image>
                  </a>
                </td>
              </tr>
              <tr v-if="theme.thumbUrls" class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>缩略图</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="block" v-for="(thumbUrl, index) in theme.thumbUrls" :key="index">
                    <a :href="getStorageUrl(theme.userName, theme.name, thumbUrl)" target="_blank">
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="getStorageUrl(theme.userName, theme.name, thumbUrl)"
                      ></el-image>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="el-table__column-resize-proxy" style="display: none"></div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ITheme } from '@/types/models';
import utils from '@/utils';

export default defineComponent({
  props: {
    theme: {
      type: Object as PropType<ITheme>,
      required: true,
    },
  },
  data() {
    return {
      tabType: 'Details',
    };
  },
  methods: {
    getResourceState(theme: ITheme) {
      return utils.getResourceState(theme.state, theme.isFeatured);
    },

    getStorageUrl(userName: string, name: string, url: string) {
      return `https://storage.sscms.com/themes/${userName}/${name}/${utils.trim(url, '/')}`;
    },
  },
  watch: {
    theme() {
      this.tabType = 'Details';
    },
  },
});
</script>
